import { render, staticRenderFns } from "./MLCCertifiedAndISOCertified.vue?vue&type=template&id=387978b3&scoped=true"
import script from "./MLCCertifiedAndISOCertified.vue?vue&type=script&lang=js"
export * from "./MLCCertifiedAndISOCertified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387978b3",
  null
  
)

export default component.exports